<template>
  <div class="m-icon-text">
    <Heading
      v-if="headline"
      :tag="headlineTag"
      :role="headlineRole"
      :size="headlineSize"
      :content="headline"
      class="m-icon-text__headline"
    />
    <component :is="listTag" :class="listClasses">
      <IconTextItem
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :paragraph="item.paragraph"
        :icon="item.icon"
        :useRoundIcon="useRoundIcon"
        :iconTheme="iconTheme"
        :iconSize="iconSize"
        :svgSize="svgSize"
        :titleSize="itemTitleSize"
        :tag="listTag === 'ul' ? 'li' : 'div'"
        :theme="itemTheme"
      />
    </component>
  </div>
</template>

<script setup lang="ts">
import './IconText.scss';
import { computed } from 'vue';
import Heading, { type HeadingProps } from '../../1-atoms/Heading/Heading.vue';
import IconTextItem, {
  type IconTextItemProps,
} from '../../2-molecules/IconTextItem/IconTextItem.vue';

export interface IconTextProps {
  items: Array<{ icon?: string; title?: string; paragraph?: string }>;
  headline?: string;
  headlineTag?: HeadingProps['tag'];
  headlineRole?: HeadingProps['role'];
  headlineSize?: HeadingProps['size'];
  useRoundIcon?: boolean;
  iconTheme?: IconTextItemProps['iconTheme'];
  iconSize?: IconTextItemProps['iconSize'];
  svgSize?: IconTextItemProps['svgSize'];
  itemTitleSize?: IconTextItemProps['titleSize'];
  listTag?: 'div' | 'ul';
  listClass?: string;
  itemTheme?: IconTextItemProps['theme'];
}

const props = withDefaults(defineProps<IconTextProps>(), {
  items: () => [],
  headline: '',
  headlineTag: 'h2',
  headlineRole: 'headline',
  headlineSize: 'medium',
  useRoundIcon: true,
  iconTheme: 'dark',
  iconSize: 'small',
  svgSize: 'small',
  itemTitleSize: 'large',
  listTag: 'div',
  listClass: '',
  itemTheme: 'light',
});

const listClasses = computed(() => ({
  'm-icon-text__list': true,
  [props.listClass]: props.listClass !== '',
}));
</script>
